import React, { useState, useEffect, Fragment, useRef } from "react";
import { useHistory, useParams } from "react-router-dom";
import "../../../assets/css/pantalla1.css";
import "../../../assets/css/Toma1.css";
import { Container, Row, Col, Label } from "reactstrap";
import { useConsentimiento } from "../../../hooks/tomaMuestra/useConsentimiento";
import { useLogin } from "../../../hooks/tomaMuestra/useLogin";
import { sendRequest } from "../../../hooks/requests/useRequest";
import DeniReactTreeView from "deni-react-treeview"
import { useSweetAlert } from "../../../hooks/sweetAlerts/useSweetAlert";
import { validarSesion } from "../../../hooks/tokens/useToken";
import { Card } from 'primereact/card';
import avatarHombre from '../../../assets/images/user/hombre.png';
import avatarMujer from '../../../assets/images/user/mujer.png';
import { Avatar } from 'primereact/avatar';


export const IndexTomaMuestra = () => {

  const { navigaConsentimientoInformado1, hour, minute, second } = useConsentimiento();

  const history = useHistory();
  const { nimm, id_sample, } = useParams();
  const { time, reload, } = useLogin();
  let name2 = localStorage.getItem('flebotomisaNombre');
  const [show, setShow] = useState(true);
  const [show1, setShow1] = useState(true);
  const [message, setMessage] = useState(true);
  const [patien, setPatien] = useState("");
  const [idGender, setIdGender] = useState(0);
  const [commetFlebotomista, setCommetFlebotomista] = useState("");
  const [itemsTree, setItemsTree] = useState([]);
  const treeviewRef = useRef(null);
  const [loadin, setLoadin] = useState(false);
  const [idW, setIdW] = useState(0);
  const [phone, setPhone] = useState("");
  const [age, setAge] = useState("");
  const [createSweet, sweetConfirmation, sweetDelete, sweetError, createSweett, sweetConfirmationUpdate, sweetConfirmRepeatExam, sweetConfirmationChangeClient, sweetConfirmationCancel, sweetValidDate, sweetDeleteBacterium1, sweetDoctorDelete, sweetAgreements, sweetAgreementMode, sweetConfirmationCsv, sweetDeleteGlobal, sweetAcceptGlobal] = useSweetAlert()
  const avatarImage = idGender === 2 ? avatarHombre : avatarMujer;


  useEffect(() => {
    if (nimm !== undefined) {
      getDataFromNimPost(nimm)
    }
  }, [nimm]);

  // ==========================================
  // INICIO DE NUEVO CÓDIGO: BLOQUEO DE GESTO "ATRÁS"
  // ==========================================
  useEffect(() => {
    // 1. Forzamos una entrada nueva en el historial al montar el componente
    window.history.pushState(null, null, window.location.href);

    const handlePopState = (event) => {
      // 2. El usuario hizo el gesto de regresar (swipe o botón atrás) en la tablet
      // Volvemos a empujar el estado para mantenerlo "atrapado" en esta vista
      window.history.pushState(null, null, window.location.href);

      // 3. Mostramos la alerta de SweetAlert para explicarle por qué no pasó nada
      createSweet(
        "warning",
        "Acción no permitida",
        "Navegación bloqueada",
        "Para evitar perder la información de la toma de muestra, por favor utiliza los botones de la pantalla."
      );
    };

    // Escuchamos el evento de navegación del historial
    window.addEventListener('popstate', handlePopState);

    // Evitar que el usuario recargue la página por accidente (F5 o swipe hacia abajo)
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = ''; // Necesario para la mayoría de navegadores modernos
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    // 4. Limpieza: Se ejecuta cuando el componente muere (para no afectar otras pantallas)
    return () => {
      window.removeEventListener('popstate', handlePopState);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []); // El array vacío equivale a ponerlo en el constructor o Page_Load de C#
  // ==========================================
  // FIN DE NUEVO CÓDIGO
  // ==========================================


  const getDataFromNimPost = async (nimm) => {
    setLoadin(false);

    let _body = {
      nim: nimm.substring(0, 13),
      id_departament: localStorage.getItem('depW')
    }

    const _response = await handleRequest("POST", "Sass/GetDataFromPatient", "sample", _body);

    if (_response !== null) {
      setLoadin(true);

      let nim = _response.lista_pruebas;

      let _isToma = await handleRequest("GET", `Sample/DetailSample/${nim[0].nim}`, 'sample');


      let is_toma = _isToma[0];
      let validateToma = is_toma.finallyFech;

      let _namePatient = ""
      let _idgender = 0
      let _comment = ""
      let _arrayNuevo = [];
      let _dataInformationStudy = [];
      let _idW = 0;
      let _phone = "";
      let _age = "";

      _response.lista_pruebas.forEach(_find => {
        _namePatient = _find.name_patient
        _idgender = _find.gender
        _comment = _find.observations_sample
        _idW = _find.id_work_order
        _phone = _find.phone
        _age = _find.age

        _arrayNuevo.push({
          "profiles": _find.listProfile,
          "exams": _find.listExam,
          "is_toma": _isToma.length > 0 && validateToma !== '' ? _isToma : ''
        })

        _dataInformationStudy.push({
          "Nuevo": _find.listExam
        })

        let tree = createTree(_arrayNuevo);
        setItemsTree(tree);

      });
      setPatien(_namePatient);
      setIdGender(_idgender);
      setCommetFlebotomista(_comment);
      setIdW(_idW);
      setPhone(_phone);
      setAge(_age);
    }
  }

  const getCancelSample = async () => {
    let _listTemp = await handleRequest("GET", `Sample/CancelSample/${nimm}`, "sample");
    if (_listTemp !== null) {
      navigateInicio();
    }
  }

  const navigateInicio = () => {
    history.push('/dashboard/defaultTomaDeMuestra');
  }


  const createTree = (_arrayNew) => {
    console.log("ðŸš€ ~ createTree ~ _arrayNew:", _arrayNew)

    let _tree = [];
    _arrayNew.forEach(_findEP => {
      if (_findEP.exams.length > 0) {
        _findEP.exams.forEach(_e => {
          let _exam_Curve = [];

          if (_e.is_curve) {
            _e.arrayCurvesSampling.forEach(_curve => {
              _exam_Curve.push({
                "id": _curve.id_work_order_sticker,
                "isLeaf": false,
                "state": _curve.is_complete ? 1 : 2,
                "text": _curve.barcode,
                "is_toma": _curve.is_toma_curve ? true : " ",
                check_forwarded: false,
              })
            });
          }
          _tree.push({
            "expanded": true,
            "children": _e?.is_curve ? _exam_Curve : [],
            "id": _e.id_work_order_exam,
            "state": _e?.is_curve ? 2 : (_e.is_toma === true || _e.check_forwarded) ? 1 : 2,
            "text": _e.name,
            "isLeaf": _e?.is_curve ? false : _e.check_specimen,
            "refused_check_specimen": (_e.is_toma === false && _e.check_forwarded === false && _e.state === 2) ? true : _e.refused_check_specimen,
            "check_forwarded": _e.check_forwarded,
            "is_toma": _findEP.is_toma
          })
        });
      }
      if (_findEP.profiles.length > 0) {
        _findEP.profiles.forEach(_e => {
          let _examenes_aux = [];
          let _checkParent = 1;
          let checy = 1;
          let exam = true;

          _e.listExam.forEach(_exam => {
            if (!_exam.check_specimen) {
              _checkParent = 2;
            }

            let examenState = _exam?.is_curve ? 2 : (_exam.is_toma === true || _exam.check_forwarded) ? 1 : 2;

            _examenes_aux.push({
              "id": _exam.id_work_order_exam,
              "isLeaf": _exam.check_specimen,
              "state": examenState,
              "text": _exam.name,
              "refused_check_specimen": (_exam.is_toma === false && _exam.check_forwarded === true && _exam.state === 2) ? true : _exam.refused_check_specimen,
              "check_forwarded": _exam.check_forwarded,
              "is_toma": _exam.is_toma
            });

            if (examenState !== 1) {
              checy = 2;
            }

            exam = _exam.refused_check_specimen;
          });

          _tree.push({
            "children": _examenes_aux,
            "state": checy,
            "text": _e.name_profile,
            "refused_check_specimen": exam,
            "is_toma": _findEP.is_toma,
            "check_forwarded": _examenes_aux.some(_ex => _ex.check_forwarded === true)
          });
        });
      }
    });
    return _tree;
  }

  const onRenderItem = (_find) => {
    return (
      <div
        className="treeview-item-example"
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%"
        }}
      >
        <div
          style={{
            flex: 1,
            minWidth: 0,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}
        >
          {
            _find.state === 1 && _find.check_forwarded === false ?
              <span style={{ color: "#51bb25" }}>
                <i className="icofont icofont-laboratory f-12"></i>
                {_find.text}
              </span>
              :
              _find.state === 1 && _find.check_forwarded === true ?
                <span>
                  <i className="icofont icofont-laboratory f-12"></i>
                  {_find.text}
                </span>
                :
                <span style={{ color: '#FF8F00' }}>
                  <i
                    style={{ color: '#FF8F00' }}
                    className="icofont icofont-laboratory f-12"
                  ></i>
                  {_find.text}
                </span>
          }
        </div>

        <ul
          style={{
            display: "flex",
            marginBottom: 0,
            marginLeft: "auto",
            marginRight: "1 px"
          }}
        >
          {renderStatusLabel(_find)}
        </ul>
      </div>
    );
  };




  const handleRequest = async (method, methodUrl, nameMethod, body = null) => {
    let requestOptions = {
      method: method
    };

    if (body !== null) {
      requestOptions = {
        ...requestOptions,
        body: JSON.stringify(body)
      };
    }

    const response = await sendRequest(requestOptions, methodUrl);

    if (response.code === 200) {
      return response.data;
    }
    else if (response.code === 401) {
      validarSesion(history, response.code, handleRequest);
    }
    else {
      createSweet("warning", "warning", nameMethod, response.data.msg);
    }
    return null;
  }


  var sizeCard = (commetFlebotomista === null || commetFlebotomista === "") ? 3 : 1
  var sizeCardStudy = (commetFlebotomista === null || commetFlebotomista === "") ? 6 : 5
  var sizephone = (commetFlebotomista === null || commetFlebotomista === "") ? 2 : 1



  const renderStatusLabel = (_find) => {

    let background = "#FFE0B2";
    let color = "#E65100";
    let text = "Sin muestra";
    let animate = false;
    let status = "warning";

    if (_find.state === 1 && _find.check_forwarded === false) {
      background = "#E8F5E9";
      color = "#2E7D32";
      text = "Con muestra";
      status = "success";
    }

    if (_find.state === 1 && _find.check_forwarded === true) {
      background = "#E3F2FD";
      color = "#1565C0";
      text = "Remitida";
      status = "forwarded";
    }

    if (_find.state !== 1) {
      animate = true;
    }

    return (
      <div
        style={{
          background,
          color,
          fontSize: "11px",
          fontWeight: 600,
          padding: "4px 12px",
          borderRadius: "20px",
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
          minWidth: "120px",
          justifyContent: "center",
          boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
          animation: animate ? "pulseSoft 3s ease-in-out infinite" : "none"
        }}
      >
        {status === "warning" && (
          <i
            className="pi pi-exclamation-triangle"
            style={{ color: "#E65100", fontSize: "13px" }}
          />
        )}

        {status === "success" && (
          <i
            className="pi pi-verified"
            style={{ color: "#2E7D32", fontSize: "13px" }}
          />
        )}

        {status === "forwarded" && (

          <i className="icofont icofont-user"
            style={{ color: "#1565C0", fontSize: "13px" }}></i>
        )}

        {text}
      </div>
    );
  };


  // * CONFIGURATION DETAIL PATIENT
  const titlePatient = <>
    <Col sm="12">
      <Row>
        <Col sm="5">

        </Col>
        <Col sm="5" style={{ textAlign: "start" }} >
          <h5>Estudios a realizar</h5>
        </Col>
      </Row>
      <Col sm="12" style={{ textAlign: "center" }}>
        <Avatar image={avatarImage} size="xlarge" shape="circle" />
      </Col>
      <Col sm="12">
        <Row>
          <Col sm="3">
            <label style={{ fontSize: "12px" }} >Nombre <br /> {patien ?? "---"} </label>
          </Col>
          <Col sm={sizephone}>
            <label style={{ fontSize: "12px" }} >Telefono <br /> {phone ?? "---"} </label>
          </Col>
          <Col sm="2">
            <label style={{ fontSize: "12px" }} >Nim <br /> {nimm ?? "---"} </label>
          </Col>
          <Col sm={sizephone}>
            <label style={{ fontSize: "12px" }} >Edad <br /> {age ?? "---"} </label>
          </Col>
          <Col sm={sizephone}>
            <label style={{ fontSize: "12px" }} >sexo <br /> {idGender === 2 ? "Masculino" : "Femenino"} </label>
          </Col>
          {
            (commetFlebotomista === null || commetFlebotomista === "") ? "" : <Col sm="3">
              <label style={{ fontSize: "12px" }} >Observacion para el flebotimista  </label>
            </Col>
          }

        </Row>
      </Col>
    </Col>
  </>






  return (
    <Fragment>
      <Container fluid={true} className="bg-barra1">
        <Col sm="12" md="12" lg="12" xl="12" className="p-0">
          <Row>

            <Col sm="12" md="12" lg="12" xl="12" className="p-l-1"> <br />
              <div className='box-departamento'>

                <div className="left-box">
                  <Label className='labelToma1 m-0'>{time}</Label>
                </div>

                <div className="center-box">
                  <label className="labelToma1 m-0">Toma de Muestra</label>
                </div>

                <div className="right-box">
                  {show1 && (
                    <>
                      <label className='rc m-0'>
                        {String(hour ?? 0).padStart(2, "0")}:
                        {String(minute ?? 0).padStart(2, "0")}:
                        {String(second ?? 0).padStart(2, "0")}
                      </label>

                      <img src={require("../../../assetsToma/imagenes/Cronometro.png")} alt="" />
                    </>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Col>
        <br />

        <Col xs="12" sm="12" md="12" lg="12" xl="12" className="p-l-0 p-r-0"  >
          <Col xs="12" sm="12" md="12" lg="12" xl="12" className="p-l-0 p-r-0" >
            {
              loadin === false ?
                <Col xs="12" sm="12" md="12" lg="12" xl="12" className='text-center p-l-0 p-r-0'>
                  <Card className='shadow' >
                    <Row className='mt-2'> <br />
                      <Col xs="12" sm="12" md="12" lg="12" xl="12" className='text-center'>  <br /> <br /> <br /> <br />
                        <img src={require("../../../assets/images/loginHelenLabs/HelenLabs.png")} className='animate__animated animate__pulse animate__infinite ' style={{ width: '130px' }} />
                      </Col>
                    </Row>
                    <Row className='mt-2'>
                      <Col sm="3" md="3" lg="3" className='text-center'></Col>
                      <Col sm="2" md="2" lg="2" className='text-left p-r-0'>
                        <p className='f-18 text-primary animate__animated animate__pulse animate__infinite'> <b>Cargando</b></p> <br />

                      </Col>
                      <Col sm="1" md="1" lg="1" className='text-center'>
                        <br />
                        <p className='animate__animated animate__fadeInDown animate__infinite text-info'><i className="fa fa-circle f-14"></i></p>
                      </Col>
                      <Col sm="1" md="1" lg="1" className='text-center'>
                        <br />
                        <p className='animate__animated animate__fadeInDown animate__slow animate__infinite text-primary'><i className="fa fa-circle f-14"></i></p>
                      </Col>
                      <Col sm="1" md="1" lg="1" className='text-center'>
                        <br />
                        <p className='animate__animated animate__fadeInDown animate__slower animate__infinite text-info'><i className="fa fa-circle f-14"></i></p>
                      </Col>
                      <Col sm="2" md="2" lg="2" className='text-center'></Col>
                    </Row>

                  </Card>
                </Col>
                :
                <Col sm="12">
                  <Row>
                    <Col sm="12">
                      <Col style={{ position: 'fixed', right: 0, bottom: 0, zIndex: 5, width: '250px', height: '380px', borderTopLeftRadius: '12px', padding: '10px' }} className='divMenu p-l-0'>
                        <Col xs="12" sm="12" md="12" lg="12" xl="12">
                          {
                            show ?
                              (
                                ""
                              )
                              :
                              (
                                <Col xs="12" sm="12" md="12" lg="12" xl="12"><br />
                                  <div className='username-Active ' >
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">
                                      <Row>
                                        <Col xs="3" sm="3" md="3" lg="3" xl="3" className='p-l-0 p-r-0 p-0' style={{ textAlign: "-webkit-center" }}>
                                          <br />
                                          <i className="fa fa-circle icon-active-small"></i>
                                        </Col>
                                        <Col xs="9" sm="9" md="9" lg="9" xl="9" className='p-l-0 p-r-0' > <br />
                                          <label className='r-label-active p-0 pointer' >{name2}</label>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </div> <br />
                                  <div className='username-Active pointer' onClick={reload} >
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">
                                      <Row>
                                        <Col xs="3" sm="3" md="3" lg="3" xl="3" className='p-l-2 p-r-0 p-0 mt-3 ' style={{ textAlign: "-webkit-center" }}>
                                          <img className=" " src={require("../../../assetsToma/imagenes/Recargar.png")} style={{ width: "40%" }} alt="" />
                                        </Col>
                                        <Col xs="9" sm="9" md="9" lg="9" xl="9" className='p-l-1 p-r-0' > <br />
                                          <label className='r-label-active p-0 pointer'>{"Recargar"}</label>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </div> <br />
                                  <div className='username-Active pointer' onClick={() => { setShow1(!show1); }}>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">
                                      <Row>
                                        <Col xs="3" sm="3" md="3" lg="3" xl="3" className='p-l-0 p-r-0 p-0' style={{ textAlign: "-webkit-center" }}> <br />
                                          <img className=" " src={require("../../../assetsToma/imagenes/Cronometro.png")} style={{ width: "45%" }} alt="" />
                                        </Col>
                                        <Col xs="9" sm="9" md="9" lg="9" xl="9" className='p-l-0 p-r-0 '> <br />
                                          <label className='r-label-active p-0 pointer'>{"Cronómetro"}</label>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </div><br />
                                  <div className='username-Active pointer' onClick={() => getCancelSample()} >
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">
                                      <Row>
                                        <Col xs="3" sm="3" md="3" lg="3" xl="3" className='p-l-0 p-r-0' style={{ textAlign: "-webkit-center" }}> <br />
                                          <img className=" " src={require("../../../assetsToma/imagenes/CerrarBlanco.png")} style={{ width: "29%" }} alt="" />
                                        </Col>
                                        <Col xs="9" sm="9" md="9" lg="9" xl="9" className='p-l-0 p-r-0 '> <br />
                                          <label className='r-label-active p-0 pointer' >{"Cancelar Toma"}</label>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </div>
                                </Col>
                              )
                          }
                        </Col>
                      </Col>
                      <Card title={titlePatient} style={{ textAlign: "center" }} >
                        <Col sm="12">
                          <Row>
                            <Col sm={sizeCard}>
                            </Col>
                            <Col sm={sizeCardStudy}>
                              <DeniReactTreeView
                                ref={treeviewRef}
                                showCheckbox={false}
                                showIcon={false}
                                items={itemsTree}
                                selectRow={false}
                                onRenderItem={onRenderItem}
                                style={{
                                  marginRight: '10px',
                                  marginBottom: '10px',
                                  height: "200px",
                                  width: "100%",
                                  textAlign: "left",
                                  border: "2px solid #1f4e69",
                                  borderRadius: "10px"
                                }}
                                className="tree-estudios"
                              />
                            </Col>
                            <Col sm="2">
                            </Col>
                            {
                              (commetFlebotomista === null || commetFlebotomista === "") ? "" :
                                <Col sm="4" >
                                  <div style={{
                                    marginRight: '10px',
                                    marginBottom: '10px',
                                    height: "200px",
                                    width: "100%",
                                    textAlign: "center",
                                    border: "2px solid #1f4e69",
                                    borderRadius: "10px",
                                    fontSize: "14px"
                                  }}>
                                    <label>{commetFlebotomista}</label>
                                  </div>
                                </Col>
                            }

                          </Row>
                        </Col>
                      </Card>
                    </Col>
                  </Row>
                </Col>
            }
          </Col>
        </Col >
        <Col xs="12" sm="12" md="12" lg="12" xl="12" className="pt-3" style={{ textAlign: "-webkit-center" }}>
          <button className="confirm-Button-study-Toma1" onClick={() => navigaConsentimientoInformado1(nimm, id_sample)}>Estos son mis estudios</button>
        </Col>


        <div className='tap-top' style={{ display: "block" }} onClick={() => { setShow(!show) }}><i className="icon-angle-double-up f-24"></i>
        </div>
      </Container >
    </Fragment >
  );
};